export interface ChatUser {
    LoginID: number | string;
    username: string;
    role?: number;
}

export interface ChatMessage {
    _id: string;
    conversationId: string;
    sender: ChatUser | number | string;
    text: string;
    mediaUrl: string | null;
    readBy: (number | string)[];
    deliveredTo: (number | string)[];
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface ChatConversation {
    _id: string;
    type: "dm" | "group";
    groupName?: string;
    groupAdmin?: ChatUser | null;
    participants: ChatUser[];
    lastMessage: ChatMessage | null;
    unreadCount: number;
    createdAt: string;
    updatedAt: string;
}

// ── Users ──
export const GET_CHAT_USERS_REQUEST = "GET_CHAT_USERS_REQUEST";
export const GET_CHAT_USERS_SUCCESS = "GET_CHAT_USERS_SUCCESS";
export const GET_CHAT_USERS_FAILURE = "GET_CHAT_USERS_FAILURE";

export const getChatUsersRequest = () => ({ type: GET_CHAT_USERS_REQUEST });
export const getChatUsersSuccess = (users: ChatUser[]) => ({ type: GET_CHAT_USERS_SUCCESS, payload: users });
export const getChatUsersFailure = (error: string) => ({ type: GET_CHAT_USERS_FAILURE, payload: error });

// ── Conversations ──
export const GET_CHAT_CONVERSATIONS_REQUEST = "GET_CHAT_CONVERSATIONS_REQUEST";
export const GET_CHAT_CONVERSATIONS_SUCCESS = "GET_CHAT_CONVERSATIONS_SUCCESS";
export const GET_CHAT_CONVERSATIONS_FAILURE = "GET_CHAT_CONVERSATIONS_FAILURE";

export const getChatConversationsRequest = () => ({ type: GET_CHAT_CONVERSATIONS_REQUEST });
export const getChatConversationsSuccess = (conversations: ChatConversation[]) => ({ type: GET_CHAT_CONVERSATIONS_SUCCESS, payload: conversations });
export const getChatConversationsFailure = (error: string) => ({ type: GET_CHAT_CONVERSATIONS_FAILURE, payload: error });

// ── Start DM ──
export const START_DM_REQUEST = "START_DM_REQUEST";
export const START_DM_SUCCESS = "START_DM_SUCCESS";
export const START_DM_FAILURE = "START_DM_FAILURE";

export const startDMRequest = (recipientId: string) => ({ type: START_DM_REQUEST, payload: { recipientId } });
export const startDMSuccess = (conversation: ChatConversation) => ({ type: START_DM_SUCCESS, payload: conversation });
export const startDMFailure = (error: string) => ({ type: START_DM_FAILURE, payload: error });

// ── Create Group ──
export const CREATE_GROUP_REQUEST = "CREATE_GROUP_REQUEST";
export const CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export const CREATE_GROUP_FAILURE = "CREATE_GROUP_FAILURE";

export const createGroupRequest = (groupName: string, memberIds: string[]) => ({
    type: CREATE_GROUP_REQUEST,
    payload: { groupName, memberIds },
});
export const createGroupSuccess = (conversation: ChatConversation) => ({ type: CREATE_GROUP_SUCCESS, payload: conversation });
export const createGroupFailure = (error: string) => ({ type: CREATE_GROUP_FAILURE, payload: error });

export const GET_CHAT_MESSAGES_REQUEST = "GET_CHAT_MESSAGES_REQUEST";
export const GET_CHAT_MESSAGES_SUCCESS = "GET_CHAT_MESSAGES_SUCCESS";
export const GET_CHAT_MESSAGES_FAILURE = "GET_CHAT_MESSAGES_FAILURE";

export const getChatMessagesRequest = (conversationId: string, page = 1, limit = 30) => ({
    type: GET_CHAT_MESSAGES_REQUEST,
    payload: { conversationId, page, limit },
});
export const getChatMessagesSuccess = (messages: ChatMessage[], conversationId: string, page: number, limit = 30) => ({
    type: GET_CHAT_MESSAGES_SUCCESS,
    payload: { messages, conversationId, page, limit },
});
export const getChatMessagesFailure = (error: string) => ({ type: GET_CHAT_MESSAGES_FAILURE, payload: error });

// ── Send Message ──
export const SEND_CHAT_MESSAGE_REQUEST = "SEND_CHAT_MESSAGE_REQUEST";
export const SEND_CHAT_MESSAGE_SUCCESS = "SEND_CHAT_MESSAGE_SUCCESS";
export const SEND_CHAT_MESSAGE_FAILURE = "SEND_CHAT_MESSAGE_FAILURE";

export const sendChatMessageRequest = (conversationId: string, text: string, mediaUrl?: string | null) => ({
    type: SEND_CHAT_MESSAGE_REQUEST,
    payload: { conversationId, text, mediaUrl },
});
export const sendChatMessageSuccess = (message: ChatMessage) => ({ type: SEND_CHAT_MESSAGE_SUCCESS, payload: message });
export const sendChatMessageFailure = (error: string) => ({ type: SEND_CHAT_MESSAGE_FAILURE, payload: error });

// ── Delete Message ──
export const DELETE_CHAT_MESSAGE_REQUEST = "DELETE_CHAT_MESSAGE_REQUEST";
export const DELETE_CHAT_MESSAGE_SUCCESS = "DELETE_CHAT_MESSAGE_SUCCESS";
export const DELETE_CHAT_MESSAGE_FAILURE = "DELETE_CHAT_MESSAGE_FAILURE";

export const deleteChatMessageRequest = (messageId: string) => ({ type: DELETE_CHAT_MESSAGE_REQUEST, payload: { messageId } });
export const deleteChatMessageSuccess = (messageId: string) => ({ type: DELETE_CHAT_MESSAGE_SUCCESS, payload: messageId });
export const deleteChatMessageFailure = (error: string) => ({ type: DELETE_CHAT_MESSAGE_FAILURE, payload: error });

// ── Upload File ──
export const UPLOAD_CHAT_FILE_REQUEST = "UPLOAD_CHAT_FILE_REQUEST";
export const UPLOAD_CHAT_FILE_SUCCESS = "UPLOAD_CHAT_FILE_SUCCESS";
export const UPLOAD_CHAT_FILE_FAILURE = "UPLOAD_CHAT_FILE_FAILURE";

export const uploadChatFileRequest = (file: File) => ({ type: UPLOAD_CHAT_FILE_REQUEST, payload: { file } });
export const uploadChatFileSuccess = (url: string) => ({ type: UPLOAD_CHAT_FILE_SUCCESS, payload: url });
export const uploadChatFileFailure = (error: string) => ({ type: UPLOAD_CHAT_FILE_FAILURE, payload: error });

export const RECEIVE_SOCKET_MESSAGE = "RECEIVE_SOCKET_MESSAGE";
export const REMOVE_SOCKET_MESSAGE = "REMOVE_SOCKET_MESSAGE";
export const CLEAR_CHAT_MESSAGES = "CLEAR_CHAT_MESSAGES";

export const receiveSocketMessage = (message: ChatMessage, conversationId: string) => ({
    type: RECEIVE_SOCKET_MESSAGE,
    payload: { message, conversationId },
});
export const removeSocketMessage = (messageId: string) => ({ type: REMOVE_SOCKET_MESSAGE, payload: messageId });
export const clearChatMessages = () => ({ type: CLEAR_CHAT_MESSAGES });